import { buildLegend, buildTooltip, buildVisualMap, mergeScatterSettings, } from "./shared";
function extractValueStats(series) {
    var min;
    var max;
    series.forEach(function (seriesItem) {
        seriesItem.data.forEach(function (point) {
            var _a;
            var value = (_a = point.value) !== null && _a !== void 0 ? _a : point.size;
            if (value === undefined || value === null) {
                return;
            }
            if (min === undefined || value < min) {
                min = value;
            }
            if (max === undefined || value > max) {
                max = value;
            }
        });
    });
    return { min: min, max: max };
}
function computeRegressionLine(points) {
    var validPoints = points
        .map(function (point) { return ({ x: point.x, y: point.y }); })
        .filter(function (point) {
        return typeof point.x === "number" && typeof point.y === "number";
    });
    var count = validPoints.length;
    if (count < 2) {
        return null;
    }
    var sums = validPoints.reduce(function (acc, point) {
        acc.sumX += point.x;
        acc.sumY += point.y;
        acc.sumXY += point.x * point.y;
        acc.sumX2 += point.x * point.x;
        return acc;
    }, { sumX: 0, sumY: 0, sumXY: 0, sumX2: 0 });
    var denominator = count * sums.sumX2 - sums.sumX * sums.sumX;
    if (denominator === 0) {
        return null;
    }
    var slope = (count * sums.sumXY - sums.sumX * sums.sumY) / denominator;
    var intercept = (sums.sumY - slope * sums.sumX) / count;
    var xs = validPoints.map(function (point) { return point.x; });
    var minX = Math.min.apply(Math, xs);
    var maxX = Math.max.apply(Math, xs);
    return {
        x1: minX,
        y1: slope * minX + intercept,
        x2: maxX,
        y2: slope * maxX + intercept,
    };
}
var scatterChartAdapter = {
    type: "scatter",
    buildOption: function (ctx) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        var data = ctx.data;
        var mergedSettings = mergeScatterSettings(ctx.settings);
        var _w = extractValueStats(data.series), min = _w.min, max = _w.max;
        var xAxis = {
            type: (_b = (_a = data.xAxis) === null || _a === void 0 ? void 0 : _a.axisType) !== null && _b !== void 0 ? _b : "value",
            name: (_c = data.xAxis) === null || _c === void 0 ? void 0 : _c.name,
            min: (_d = data.xAxis) === null || _d === void 0 ? void 0 : _d.min,
            max: (_e = data.xAxis) === null || _e === void 0 ? void 0 : _e.max,
            axisLabel: (_f = data.xAxis) === null || _f === void 0 ? void 0 : _f.axisLabel,
            axisLine: ((_g = data.xAxis) === null || _g === void 0 ? void 0 : _g.showAxisLine) === false
                ? { show: false }
                : ((_h = data.xAxis) === null || _h === void 0 ? void 0 : _h.showAxisLine) === true
                    ? { show: true }
                    : undefined,
        };
        var yAxis = {
            type: (_k = (_j = data.yAxis) === null || _j === void 0 ? void 0 : _j.axisType) !== null && _k !== void 0 ? _k : "value",
            name: (_l = data.yAxis) === null || _l === void 0 ? void 0 : _l.name,
            min: (_m = data.yAxis) === null || _m === void 0 ? void 0 : _m.min,
            max: (_o = data.yAxis) === null || _o === void 0 ? void 0 : _o.max,
            axisLabel: (_p = data.yAxis) === null || _p === void 0 ? void 0 : _p.axisLabel,
            axisLine: ((_q = data.yAxis) === null || _q === void 0 ? void 0 : _q.showAxisLine) === false
                ? { show: false }
                : ((_r = data.yAxis) === null || _r === void 0 ? void 0 : _r.showAxisLine) === true
                    ? { show: true }
                    : undefined,
        };
        var legend = buildLegend(data.legend, mergedSettings.legend);
        var tooltip = buildTooltip(data.tooltip, {
            trigger: (_t = (_s = mergedSettings.tooltip) === null || _s === void 0 ? void 0 : _s.trigger) !== null && _t !== void 0 ? _t : "item",
            enable: (_u = mergedSettings.tooltip) === null || _u === void 0 ? void 0 : _u.enable,
            formatter: (_v = mergedSettings.tooltip) === null || _v === void 0 ? void 0 : _v.formatter,
        });
        var visualMap = buildVisualMap(data.visualMap, mergedSettings.visualMap, { min: min, max: max });
        var series = data.series.map(function (seriesItem) {
            var _a, _b;
            var regression = mergedSettings.showRegressionLine
                ? computeRegressionLine(seriesItem.data)
                : null;
            return {
                type: "scatter",
                name: seriesItem.name,
                symbol: (_a = seriesItem.symbol) !== null && _a !== void 0 ? _a : "circle",
                symbolSize: (_b = seriesItem.symbolSize) !== null && _b !== void 0 ? _b : 12,
                data: seriesItem.data.map(function (point) {
                    var _a, _b;
                    return ({
                        value: [point.x, point.y, (_b = (_a = point.value) !== null && _a !== void 0 ? _a : point.size) !== null && _b !== void 0 ? _b : null],
                        name: point.name,
                        symbolSize: point.size,
                        itemStyle: point.color ? { color: point.color } : undefined,
                    });
                }),
                itemStyle: seriesItem.color ? { color: seriesItem.color } : undefined,
                emphasis: { focus: "series" },
                markLine: regression
                    ? {
                        symbol: "none",
                        lineStyle: { type: "dashed" },
                        data: [
                            [
                                { coord: [regression.x1, regression.y1] },
                                { coord: [regression.x2, regression.y2] },
                            ],
                        ],
                    }
                    : undefined,
            };
        });
        var option = {
            xAxis: xAxis,
            yAxis: yAxis,
            legend: legend,
            tooltip: tooltip,
            series: series,
        };
        if (visualMap) {
            option.visualMap = visualMap;
        }
        return option;
    },
    getDefaultSettings: function () { return ({
        legend: { show: true, position: "top" },
        tooltip: { enable: true, trigger: "item" },
        visualMap: { show: false, calculable: true },
        showRegressionLine: false,
    }); },
};
export default scatterChartAdapter;
